/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'zhiding': {
    width: 16,
    height: 16,
    viewBox: '0 0 123.67 121.83',
    data: '<rect pid="0" x="12.03" y="5.88" width="97.33" height="7.67" rx="3.83" ry="3.83"/><rect pid="1" x="19.64" y="32.03" width="51.35" height="7.67" rx="3.83" ry="3.83" transform="rotate(-45 45.305 35.864)"/><rect pid="2" x="50.4" y="32.03" width="51.35" height="7.67" rx="3.83" ry="3.83" transform="rotate(-135 76.074 35.86)"/><rect pid="3" x="12.28" y="63.46" width="97.33" height="7.67" rx="3.83" ry="3.83" transform="rotate(90 60.95 67.29)"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/zhiding.js